import { adaptShoppingContext } from 'stores/adapters/bex-api/migration-adapters/property-info/shopping-context-response-adapter';

import { HotelRoomsAndRatesViewModel } from 'models';

import { adaptErrorMessage, adaptErrorMessageModel } from './error-message-adapter';
import { adaptFlyInModel } from './property-toast-message-adapter';
import { adaptLegalBannerMessagingCard, adaptMessagingCard } from './property-offers-message-adapter';
import { adaptStickyOffer } from './property-stickyBar-adapter';
import { FetchResult } from '@apollo/client';
import { PropertyOffers } from 'src/common/__generated__/api';

export const adaptPropertyInfoOffers = (response: FetchResult<PropertyOffers.Query>): HotelRoomsAndRatesViewModel => {
  if (!response) {
    return null;
  }

  const errorMessage = response?.data?.propertyOffers?.errorMessage;
  const filterPills = getFilterPills(response);
  const legalDisclaimer = getPropertyLoyaltyDisclaimer(response);
  const loading = getLoading(response);
  const loyaltyDiscount = getPropertyLoyaltyDiscount(response);
  const partnerPropertySearchLink = getPartnerPropertySearchLink(response);
  const propertyLevelOffersMessage = response?.data?.propertyOffers?.propertyLevelOffersMessage;
  const propertySearchLink = getPropertySearchLink(response);
  const serpMetadata = getSerpMetaData(response);
  const shoppingContext = getShoppingContext(response);
  const singleUnitOffer = response?.data?.propertyOffers?.singleUnitOffer;
  const singleUnitOfferDialog = response?.data?.propertyOffers?.singleUnitOfferDialog;
  const spaceDetails = response?.data?.propertyOffers?.spaceDetails;

  return {
    errorMessage: adaptErrorMessage(errorMessage),
    errorMessagingModel: adaptErrorMessageModel(errorMessage),
    flyInModel: adaptFlyInModel(response),
    filterPills,
    legalBanner: adaptLegalBannerMessagingCard(response),
    legalDisclaimer,
    loading,
    loyaltyDiscount,
    messagingCardModel: adaptMessagingCard(response),
    partnerPropertySearchLink,
    propertyHighlightSection: getPropertyHighlightSection(response),
    propertyLevelOffersMessage,
    propertySearchLink,
    serpMetadata,
    shoppingContext,
    singleUnitOffer,
    singleUnitOfferDialog,
    spacesViewModel: spaceDetails,
    stickyOffer: adaptStickyOffer(response),
  } as HotelRoomsAndRatesViewModel;
};

const getFilterPills = response => response?.data?.propertyOffers?.filterPills;
const getLoading = response => response?.data?.propertyOffers?.loading;
const getPartnerPropertySearchLink = response => response?.data?.propertyOffers?.partnerPropertySearchLink;
const getPropertyHighlightSection = response => response?.data?.propertyOffers?.propertyHighlightSection;
const getPropertyLoyaltyDiscount = response => response?.data?.propertyOffers?.loyaltyDiscount;
const getPropertyLoyaltyDisclaimer = response => response?.data?.propertyOffers?.legalDisclaimer;
const getPropertySearchLink = response => response?.data?.propertyOffers?.propertySearchLink;
const getSerpMetaData = response => response?.data?.propertyOffers?.serpMetadata;
const getShoppingContext = response => adaptShoppingContext(response?.data?.propertyOffers?.shoppingContext?.multiItem);
